import {
  Box,
  Text,
  Button,
  Icon,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { Link as RemixLink } from "@remix-run/react";
import { useWatch } from "react-hook-form";
import { format } from "date-fns";
import { MdRoute } from "react-icons/md";

/**
 * On a single backcountry site that belongs to a trip-planner area: the
 * choice between watching just this site and planning a route with a
 * different site each night. It leads with that choice, because a card
 * titled with the area's name and a "Plan a trip" button didn't say when the
 * button was for. It stays to two short lines on a phone; the section header
 * already says it's optional, and the button is easy to come back from.
 */
export function TripPlannerNudge({ facility, tripPlannerParent, formContext }) {
  const siteName = facility.sites[0]?.name || facility.name;

  // Carry the days already picked here, so switching doesn't start over
  const selectedDates =
    useWatch({ control: formContext.control, name: "selectedDates" }) || [];
  const params = new URLSearchParams({
    aliasType: "site",
    aliasLabel: siteName,
  });
  if (selectedDates.length > 0) {
    params.set(
      "dates",
      [...selectedDates]
        .sort((a, b) => a - b)
        .map((day) => format(day, "yyyy-MM-dd"))
        .join(","),
    );
  }
  const tripPlannerUrl = `/new/${tripPlannerParent.slug}?${params}`;

  const bg = useColorModeValue("brand.50", "whiteAlpha.100");
  const borderColor = useColorModeValue("brand.200", "brand.700");
  const accentColor = useColorModeValue("brand.500", "brand.400");

  return (
    <Box
      borderWidth="1px"
      borderColor={borderColor}
      borderLeftWidth="3px"
      borderLeftColor={accentColor}
      borderRadius="md"
      p={4}
      bg={bg}
    >
      <VStack align="start" spacing={2}>
        <Text fontWeight="semibold">
          Staying somewhere else on other nights?
        </Text>
        <Text fontSize="sm" color="muted">
          The trip planner watches a different site each night, as one trip.
        </Text>
        <Button
          as={RemixLink}
          to={tripPlannerUrl}
          colorScheme="brand"
          size="sm"
          leftIcon={<Icon as={MdRoute} />}
        >
          Plan the whole trip
        </Button>
      </VStack>
    </Box>
  );
}
